import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

type Placement = "bottom" | "up";
@Component({
  selector: "app-info-popover",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./info-popover.component.html",
})
export class InfoPopoverComponent {
  isHovered = false;
  popoverTimeout: any; // prevent the popover to close right away, causing jittering for user
  @Input() infoType!: string;

  readonly onMouseEnter = () => {
    clearTimeout(this.popoverTimeout);
    this.isHovered = true;
  };

  readonly onMouseLeave = () => {
    this.popoverTimeout = setTimeout(() => {
      this.isHovered = false;
    }, 200);
  };
}
